import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=a877cb7c&scoped=true"
import script from "./Events.vue?vue&type=script&lang=ts"
export * from "./Events.vue?vue&type=script&lang=ts"
import style0 from "./Events.vue?vue&type=style&index=0&id=a877cb7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a877cb7c",
  null
  
)

export default component.exports